export const factoryJobPostKey = (postingId: string) =>
  ['JOB_POST', postingId] as const;
